import { render, staticRenderFns } from "./ModalDetalharProtocolosPssc.vue?vue&type=template&id=45ad3d21&lang=pug"
import script from "./ModalDetalharProtocolosPssc.vue?vue&type=script&lang=js"
export * from "./ModalDetalharProtocolosPssc.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalharProtocolosPssc.vue?vue&type=style&index=0&id=45ad3d21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports